"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSplitRecordToUnifiedRecord = exports.RegisterAPI = exports.toEditingRecord = void 0;
const Networking_1 = require("../tools/Networking");
function toEditingRecord(record) {
    return Object.assign(Object.assign({}, record), { type: record.key.split('.')[0], key: record.key.split('.')[1] });
}
exports.toEditingRecord = toEditingRecord;
class RegisterAPI {
    constructor(baseUri) {
        this.baseUri = baseUri;
        this.net = new Networking_1.Networking(baseUri);
    }
    editAccountManager(params) {
        return this.net.post('account/edit/manager', params);
    }
    editAccountOwner(params) {
        return this.net.post('account/edit/owner', params);
    }
    editAccountRecords(params) {
        return this.net.post('account/edit/records', params);
    }
    sendTransaction(params) {
        return this.net.post('transaction/send', {
            sign_key: params.sign_key,
            sign_list: params.sign_list,
        });
    }
}
exports.RegisterAPI = RegisterAPI;
function fromSplitRecordToUnifiedRecord() {
}
exports.fromSplitRecordToUnifiedRecord = fromSplitRecordToUnifiedRecord;
//# sourceMappingURL=RegisterAPI.js.map